(function () {
  function initCarousel(sid) {
    var carousel = document.getElementById(sid);
    if (!carousel) return;

    var slides  = carousel.querySelectorAll('.shc-slide');
    var dots    = carousel.querySelectorAll('.shc-dot');
    var btnPrev = document.getElementById(sid + '-prev');
    var btnNext = document.getElementById(sid + '-next');
    var total   = slides.length;
    var current = 0;
    var timer   = null;
    var autoplayMs = parseInt(carousel.dataset.autoplay || '4000', 10);

    if (total <= 1) return;

    function goTo(index) {
      slides[current].classList.remove('is-active');
      dots[current].classList.remove('is-active');
      dots[current].setAttribute('aria-selected', 'false');
      current = (index + total) % total;
      slides[current].classList.add('is-active');
      dots[current].classList.add('is-active');
      dots[current].setAttribute('aria-selected', 'true');
    }

    function startAutoplay() {
      clearInterval(timer);
      if (autoplayMs > 0) {
        timer = setInterval(function () { goTo(current + 1); }, autoplayMs);
      }
    }

    if (btnPrev) btnPrev.addEventListener('click', function () { goTo(current - 1); startAutoplay(); });
    if (btnNext) btnNext.addEventListener('click', function () { goTo(current + 1); startAutoplay(); });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(this.dataset.index, 10));
        startAutoplay();
      });
    });

    var touchStartX = 0;
    carousel.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].clientX;
    }, { passive: true });
    carousel.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dx) > 40) { goTo(dx < 0 ? current + 1 : current - 1); startAutoplay(); }
    }, { passive: true });

    carousel.addEventListener('mouseenter', function () { clearInterval(timer); });
    carousel.addEventListener('mouseleave', startAutoplay);

    startAutoplay();
  }

  // Init all carousels on page
  function initAll() {
    document.querySelectorAll('.snipes-hero-carousel').forEach(function (el) {
      initCarousel(el.id);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify theme editor re-init on section load
  document.addEventListener('shopify:section:load', function (e) {
    var carousel = e.target.querySelector('.snipes-hero-carousel');
    if (carousel) initCarousel(carousel.id);
  });
})();
